import { FunctionComponent, useState } from 'react'
import styles from '../export.module.scss'
import { BrowserUpdated } from '@mui/icons-material'
import ExportDialog from '../exportDialog.tsx'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import { ExportDataType } from '@/types/Export.ts'

interface ExportEventsProps {
    daycares: Daycare[]
    minDate: string
    isRpeOrLaep: boolean
}

const ExportEvents: FunctionComponent<ExportEventsProps> = ({ daycares, minDate, isRpeOrLaep }: ExportEventsProps) => {
    const { t } = useTranslation()

    const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false)

    return (
        <>
            <a className={styles.Case} onClick={(): void => setIsDialogOpen(true)}>
                <p className={styles.CaseTitle}>{t('events')}</p>
                <BrowserUpdated className={styles.CaseIcon} />
            </a>
            {isDialogOpen && (
                <ExportDialog
                    type={ExportDataType.Events}
                    open={isDialogOpen}
                    handleClose={(): void => setIsDialogOpen(false)}
                    daycares={daycares}
                    minDate={minDate}
                    isRpeOrLaep={isRpeOrLaep}
                />
            )}
        </>
    )
}

export default ExportEvents
